// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__E6dIP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__-Qc3v"};